// Visibility flags for the "upload-geometry-notice" dark modal (AppLocation KML upload).
// - session flag: set on "Proceed", so the notice shows once per tab session
// - dismissed flag: set on "Proceed" with "Don't show again" ticked, persists per user on this device
// Storage access is wrapped in try/catch: it can throw in private mode or with blocked site data.

const SESSION_KEY = "upload-geometry-notice-seen"
const getDismissedKey = (userId?: Maybe<string>) => `upload-geometry-notice-dismissed:${userId ?? "anon"}`

export const isUploadGeometryNoticeSeenThisSession = (): boolean => {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1"
  } catch {
    return false
  }
}

export const markUploadGeometryNoticeSeenThisSession = (): void => {
  try {
    sessionStorage.setItem(SESSION_KEY, "1")
  } catch {
    // storage unavailable — notice will simply show again
  }
}

export const isUploadGeometryNoticeDismissed = (userId?: Maybe<string>): boolean => {
  try {
    return localStorage.getItem(getDismissedKey(userId)) === "1"
  } catch {
    return false
  }
}

export const dismissUploadGeometryNotice = (userId?: Maybe<string>): void => {
  try {
    localStorage.setItem(getDismissedKey(userId), "1")
  } catch {
    // storage unavailable — notice will simply show again
  }
}

export const shouldShowUploadGeometryNotice = (userId?: Maybe<string>): boolean =>
  !isUploadGeometryNoticeSeenThisSession() && !isUploadGeometryNoticeDismissed(userId)
